import gql from 'graphql-tag';

export const fields = `
    engineModel {
        id
        name
    }
    potentialIssue {
        id
        name
    }
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateEngineModelsPotentialIssues (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateEngineModelsPotentialIssues (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetEngineModelsPotentialIssues (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetEngineModelsPotentialIssues (
            query: $query
            constraint: $constraint
        ) {
            engineModelId
            potentialIssueId
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindEngineModelPotentialIssueById (
        $engineModelId: ID
        $potentialIssueId: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindEngineModelPotentialIssueById (
            engineModelId: $engineModelId
            potentialIssueId: $potentialIssueId
            constraint: $constraint
        ) {
            engineModelId
            potentialIssueId
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindEngineModelPotentialIssue (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindEngineModelPotentialIssue (
            query: $query
            constraint: $constraint
        ) {
            engineModelId
            potentialIssueId
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateEngineModelPotentialIssue (
        $payload: DigitaiCreateEngineModelPotentialIssueInput!
    ) {
        digitaiCreateEngineModelPotentialIssue (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateEngineModelsPotentialIssues (
        $payload: [DigitaiCreateEngineModelPotentialIssueInput]!
    ) {
        digitaiCreateEngineModelsPotentialIssues (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateEngineModelPotentialIssueById (
        $payload: DigitaiUpdateEngineModelPotentialIssueByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateEngineModelPotentialIssueById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateEngineModelsPotentialIssues (
        $payload: DigitaiUpdateEngineModelsPotentialIssuesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateEngineModelsPotentialIssues (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteEngineModelPotentialIssueById (
        $engineModelId: ID!
        $potentialIssueId: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteEngineModelPotentialIssueById (
            engineModelId: $engineModelId
            potentialIssueId: $potentialIssueId
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteEngineModelsPotentialIssues (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteEngineModelsPotentialIssues (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
